"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerErrorsContext = void 0;
var _react = _interopRequireDefault(require("react"));
/** Context for keeping track of errors from the server */

const ServerErrorsContext = exports.ServerErrorsContext = /*#__PURE__*/_react.default.createContext({});